import {ClientFileInterface, VectorFileInterface} from "../../pages/ProfilePage/interfaces";
import React, {useState, useEffect} from "react";
import iconTrash from "url:shared-assets/icons/trash.svg";
import iconSparkles from "url:shared-assets/animations/sparkles_animated_infinite.svg";
import {CONFIG} from "../../constants";
import Api from "../../services/Api";
import CustomButton from "../CustomButton";

interface Props {
  lang: string;
  customerFiles: Array<VectorFileInterface>
}

const valid_content_types = [
  "application/pdf",
  "text/plain",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
]

const ClientFiles: React.FC<Props> = (props: Props) => {
  const api = Api.getInstance();
  const [clientFiles, setClientFiles] = useState<Array<ClientFileInterface>>([]);
  const [fileChanged, setFileChanged] = useState(false);
  const [fileData, setFileData] = useState("");
  const [filename, setFilename] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    api.get("client/client_files").then(response => {
      setClientFiles(response.json.clientFiles);
    })
  }

  const uploadImage = (evt: any) => {
    if (evt === null) {
      alert('Empty event');
      return;
    }

    const clientFile = evt.target.files[0];
    if (!clientFile) {
      console.log('No file')
      return
    }

    if (valid_content_types.indexOf(clientFile.type) === -1) {
      alert('This is not a valid file: ' + clientFile.type + '. Upload a pdf, a word document or plain text.');
      return;
    }

    setFilename(clientFile.name);

    const reader = new FileReader();

    reader.onload = ((theFile) => {
      return (e: any) => {
        setFileChanged(true);
        setFileData(e.target.result);
      };
    })(clientFile);
    reader.readAsDataURL(clientFile);
  }

  const save = () => {
    setUploading(true);
    const data = {
      file_name: filename,
      file_data: fileData
    }
    api.post('client/upload/file', data).then(result => {
      setFileChanged(false);
      setFileData("");
      setFilename("");
      setUploading(false);
      getData();
    })
  }

  const askDelete = (fileId: string) => {
    if (confirm("Are you sure you want to delete this file?")) {
      api.get("client/client_file_delete/" + fileId).then(response => {
        getData();
      })
    }
  }

  const getFile = (fileId: string, customer: boolean) => {
    const url = CONFIG.API_ENDPOINT + (customer ? "client/vector_file/" : "client/client_file_get/") + fileId;
    api.getRaw(url).then(response => {
      response.blob().then(data => {
        const _type = data.type === "text/plain" ? "text/plain; charset=UTF-8" : data.type;
        const file = new Blob([data], {type: _type});
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, "_blank");
      })

    })
  }

  return (
    <>
      <p className="mt-6 z-heading2">{props.lang === "sv" ? "Mina dokument" : "My documents"}</p>
      {
        clientFiles.map(cf => {
          return (
            <div key={"cf_" + cf.id} className="mt-2 flex justify-between items-center">
              <p className="z-link" onClick={() => getFile(cf.id, false)}>{cf.filename}</p>
              <img src={iconTrash} alt="delete" className="h-8 w-8 p-1 rounded-full hover:bg-indigo-800 cursor-pointer"
                   onClick={() => askDelete(cf.id)}/>
            </div>
          )
        })
      }
      <div className="mt-4 p-4 border border-dashed border-indigo-800 flex justify-between items-center">
        <div>
          <input id="profileFile" type="file" className="hidden"
                 onChange={(e) => uploadImage(e)}/>
          <label htmlFor="profileFile" className="underline cursor-pointer">
            {
              props.lang === 'sv' ?
                fileChanged ? 'Byt fil' : 'Välj fil' :
                fileChanged ? 'Change file' : 'Choose file'
            }
          </label>
        </div>
        {
          filename &&
          <div>{filename}</div>
        }
        <div>
          {
            uploading ? (
              <div className="flex items-center p-3 rounded-md gap-x-2">
                <img src={iconSparkles} alt="thinking" className="h-6 w-6"/>
                <div className="z-body1">Uploading and summarizing...</div>
              </div>
            ) : (
              <CustomButton disabled={!fileChanged} onClick={() => save()}>
                {props.lang === "sv" ? "Ladda upp" : "Upload"}
              </CustomButton>
            )
          }

        </div>

      </div>

      <p className="mt-6 z-heading2">{props.lang === "sv" ? "Företagsinformation" : "Company Information"}</p>
      {
        props.customerFiles.map(cf => {
          return (
            <p key={"cf_" + cf.id} className="z-link mt-2" onClick={() => getFile(cf.id, true)}>
              {cf.filename}
            </p>
          )
        })
      }
      {
        props.customerFiles.length === 0 &&
          <div className="z-body1">{props.lang === "sv" ? "Nothing uploaded" : "Inga uppladdade filer"}</div>
      }
    </>
  )
}

export default ClientFiles;